import * as React from "react";
const SvgX = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", preserveAspectRatio: "none", style: {
  width: "100%",
  height: "100%"
}, ...props }, /* @__PURE__ */ React.createElement("line", { x1: 0, y1: 0, x2: 100, y2: 100, stroke: "#364e64", strokeWidth: 15 }), /* @__PURE__ */ React.createElement("line", { x1: 100, y1: 0, x2: 0, y2: 100, stroke: "#364e64", strokeWidth: 15 }));
export default SvgX;
